// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.smart-components-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 15px;
  margin: 15px;
}

.dragItem {
  display: flex;
  align-items: center;
  gap: 10px;
  background: white;
  border: 1px solid var(--ion-color-medium-tint);
  border-radius: 10px;
  min-height: 60px;
  padding: 10px;
  font-size: 18px;
  font-weight: 600;
}
.dragItem.counter {
  border-color: var(--ion-color-primary);
  background-color: var(--ion-color-primary);
  color: var(--ion-color-primary-contrast);
}
.dragItem.counter ion-icon {
  color: var(--ion-color-primary-contrast);
}
.dragItem ion-icon {
  font-size: 32px;
  color: var(--ion-color-primary);
}

:host-context(.vimar) .dragItem.counter {
  border-color: var(--ion-color-light);
  background-color: var(--ion-color-light);
  color: var(--label-color);
}
:host-context(.vimar) .dragItem.counter ion-icon {
  color: var(--label-color);
}

.cdk-drag.active {
  cursor: move;
}
.cdk-drag.active.cdk-drag-dragging {
  cursor: grabbing;
  z-index: 100;
}

@media screen and (min-width: 1400px) {
  .smart-components-list {
    grid-template-columns: repeat(4, 1fr);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/container-smart-component-grid/container-smart-component-grid.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,2DAAA;EACA,SAAA;EACA,YAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,8CAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AACJ;AACI;EACI,sCAAA;EACA,0CAAA;EACA,wCAAA;AACR;AACQ;EACI,wCAAA;AACZ;AAGI;EACI,eAAA;EACA,+BAAA;AADR;;AAKA;EACI,oCAAA;EACA,wCAAA;EACA,yBAAA;AAFJ;AAII;EACI,yBAAA;AAFR;;AAMA;EACI,YAAA;AAHJ;AAKI;EACI,gBAAA;EACA,YAAA;AAHR;;AAOA;EACI;IACI,qCAAA;EAJN;AACF","sourcesContent":[".smart-components-list {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    gap: 15px;\n    margin: 15px;\n}\n\n.dragItem {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    background: white;\n    border: 1px solid var(--ion-color-medium-tint);\n    border-radius: 10px;\n    min-height: 60px;\n    padding: 10px;\n    font-size: 18px;\n    font-weight: 600;\n\n    &.counter {\n        border-color: var(--ion-color-primary);\n        background-color: var(--ion-color-primary);\n        color: var(--ion-color-primary-contrast);\n\n        ion-icon {\n            color: var(--ion-color-primary-contrast);\n        }\n    }\n\n    ion-icon {\n        font-size: 32px;\n        color: var(--ion-color-primary);\n    }\n}\n\n:host-context(.vimar) .dragItem.counter {\n    border-color: var(--ion-color-light);\n    background-color: var(--ion-color-light);\n    color: var(--label-color);\n\n    ion-icon {\n        color: var(--label-color);\n    }\n}\n\n.cdk-drag.active {\n    cursor: move;\n\n    &.cdk-drag-dragging {\n        cursor: grabbing;\n        z-index: 100;\n    }\n}\n\n@media screen and (min-width: 1400px) {\n    .smart-components-list {\n        grid-template-columns: repeat(4, 1fr);\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
